export default __webpack_public_path__ + "static/LabelWithIconPadding-5d194cfcbdb1f017305a7aae0afdc6a0.png";